export interface TaskModalReadyInput {
    // Resolved task id (null/undefined until the number resolves to a task).
    taskId: string | null | undefined
    hasTask: boolean
    hasProject: boolean
    // A cold deep link (no backgroundLocation in history state).
    isDeepLink: boolean
    isAuthed: boolean
    statusesLoaded: boolean // statuses.length > 0
    membersLoaded: boolean // members.length > 0
    membersInitialized: boolean // the members listener has delivered at least once
    descriptionReady: boolean // task.description !== undefined (loaded)
    hasAssignee: boolean // !!task.assigneeId
}

// Single gate for opening the task modal (extracted from WorkspaceTaskModalRoute so it's
// unit-testable). Two things it guarantees:
//   1. On an authed deep link, wait for the full card minimum — statuses + members + description —
//      so the card paints complete in one go instead of popping in parts (SCD-903).
//   2. Whenever the task has an assignee, wait until the members list has initialized so the
//      assignee can resolve. The deep-link fetch delivers the task (with its assigneeId) before
//      the members list, so opening earlier flashes "Unassigned" and then swaps to the real
//      assignee (SCD-916). A former-member assignee still opens — the list has loaded, so the chip
//      just shows a fallback name rather than blocking the card forever.
export function computeTaskModalReady(i: TaskModalReadyInput): boolean {
    const needsFullMinimum = i.isDeepLink && i.isAuthed
    const supportReady = i.statusesLoaded && i.membersLoaded
    const fullMinimumReady = !needsFullMinimum || (supportReady && i.descriptionReady)
    const assigneeReady = !i.hasAssignee || i.membersInitialized
    return !!(i.taskId && i.hasTask && i.hasProject && fullMinimumReady && assigneeReady)
}
